<template>
  <div class="filament" :data-content="$t('printers.item.extruder')" :style="{'border-color': color, 'color': color}">{{filamentLeft}}<span class="text--muted text--400">{{filamentMore}}</span></div>
</template>

<script>

  import MaterialsMixin from "@/mixins/materials";

  const defaultColor = '#0984e3';

  export default {
    name: 'printer-filament-label',
    props: ['filament', 'exCount', 'ex', 'nozzle'],
    mixins: [MaterialsMixin],
    computed: {
      value() {
        return this.filament||{};
      },
      filamentLeft() {
        let res = (this.value.w||0) + this.$t('measure.shortcut.gram');

        return res;
      },
      filamentMore() {
        let res = '';
        //Material
        if (this.value.m) {
          let materialName = this.materialsMap[this.value.m] !== undefined ? this.materialsMap[this.value.m] : this.value.m;
          res += ' • ' + materialName;
        }
        //Nozzle
        if (this.nozzle) {
          res += ' • ' + this.nozzle + this.$t('measure.shortcut.millimeter');
        }

        return res;
      },
      color() {
        return this.filament.c||defaultColor;
      }
    }
  }
</script>
